
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import moment from "moment";
import { createDepreciationRate, updateDepreciationRate } from '../../api/apiDepreciationRate';
import WrappedTextField from 'common/components/custom/WrappedTextField';
import NumberFormat from "react-number-format";
import WrappedKeyboardDatePicker from 'common/components/custom/WrappedKeyboardDatePicker';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class CreateRate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            newRate: {
                rate: 0,
                startDate: null
            },
            selectedStartDate: null
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.depreciationRatesToEdit != null) {
            if (prevState.newRate.id !== this.props.depreciationRatesToEdit.id) {
                this.setState({ newRate: this.props.depreciationRatesToEdit, selectedStartDate: moment(new Date(this.props.depreciationRatesToEdit.startDate)).format("DD-MM-YYYY") });
            }
        }
    }

    handleChangeStartDate = (date) => {
        let { newRate } = this.state
        newRate.startDate = moment(date).format("DD-MM-YYYY")
        this.setState({ newRate: newRate, selectedStartDate: date });
    }

    handleChange = (values) => {
        let { newRate } = this.state;
        newRate.rate = values.value;
        this.setState({ newRate: newRate })
    };

    createDepreciationRate = (e) => {
        e.preventDefault();
        let { newRate } = this.state

        if (!this.validateForm()) {
            return;
        }

        let action = this.props.depreciationRatesToEdit ? updateDepreciationRate : createDepreciationRate;
        action(this.props.depreciationRatesToEdit ? newRate : newRate, { params: { assetId: this.props.assetId } }).then(response => {
            this.props.enqueueSnackbar(this.props.t(this.props.depreciationRatesToEdit ? 'update_message_depreciation_rate' : 'create_message_depreciation_rate'), { variant: 'success' });
            this.closeDialog()
            this.props.getRateDetailsByAssetId()
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t(this.props.depreciationRatesToEdit ? 'error_update_message' : 'error_create_message', { title: this.props.t('depreciation_rate') }), { variant: 'error' });
        });
    }

    validateForm() {
        let { newRate } = this.state;
        let valid = true;
        if (!newRate.rate || !newRate.startDate
        ) {
            valid = false;
        }
        return valid;
    }

    closeDialog = () => {
        this.props.closeDialog();
        this.setState({ newRate: { rate: 0, startDate: null }, selectedStartDate: null });
    }

    render() {
        let { newRate, selectedStartDate } = this.state
        let { depreciationRatesToEdit } = this.props;

        return (
            <Dialog open={this.props.isOpen} TransitionComponent={Transition}>
                <DialogTitle className="dialog-header-custom" onClose={this.closeDialog}>{depreciationRatesToEdit ? this.props.t("edit_rate") : this.props.t("new_rate")}</DialogTitle>
                <form onSubmit={this.createDepreciationRate} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container direction="row" spacing={2}>
                                <Grid item container>
                                    <NumberFormat
                                        customInput={WrappedTextField}
                                        label={"rate"}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        value={newRate.rate}
                                        onValueChange={this.handleChange}
                                    />
                                </Grid>
                                <Grid item container>
                                    <WrappedKeyboardDatePicker
                                        name="selectedStartDate"
                                        label={this.props.t("starting_date_of_usage")}
                                        value={selectedStartDate ? Date.parse(selectedStartDate) : null}
                                        onChange={this.handleChangeStartDate}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.closeDialog} variant="contained">
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained">
                            {depreciationRatesToEdit ? this.props.t("update") : this.props.t("create")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog >
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(CreateRate)));
